<div id="generalDialog" appDraggable dragTarget="#generalDialog" dragHandle="#generalDialogHeader"
    class="modal fade in ui-draggable ui-draggable-handle locationAlertDataPane"
    style="width:auto; min-width: 450px; max-width: 100%; min-height: 200px; height: auto; overflow-y: auto; max-height: 100%; display: none;"
    role="dialog" tabindex="-1">

    <div class="modal-content modal-dialog">

        <div class="modal-header" id="generalDialogHeader">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="hide()">
                <span aria-hidden="true">x</span>
            </button>
            <h4 class="modal-title">
                <span>Execute Function :-&nbsp;{{ function.name }} ?</span>
            </h4>
        </div>

        <div class="modal-body row" id="{{getFunctionParametersTabId()}}">
            <ng-container *ngFor="let functionDataUi of functionParameterData">
                <!-- Function Parameter Name-->
                    <div class="col-sm-12">
                        <div class="col-sm-6">
                            <div class="objectParam labelNormal">
                                {{functionDataUi?.functionParameter?.name}}
                            </div>
                        </div>

                <!-- Function Parameter Value(s) -->

                        <div class="col-sm-6">
                            <ng-container *ngFor="let dataObject of functionDataUi.dataObjects; let i = index">
                                <div class="row">
                                    <!-- Multi-Value Buttons (Add / Remove)-->
                                    <div class="col-sm-1">
                                        <ng-container *ngIf="functionDataUi?.functionParameter?.multiValue">
                                            <ng-container *ngIf="i == 0">
                                                <button class="btn btn-ef" (click)="addNewValue(functionDataUi)">
                                                    <i class="fa fa-plus"></i>
                                                </button>
                                            </ng-container>
                                            <ng-container *ngIf="i > 0">
                                                <button class="btn btn-default" (click)="removeValueAtIndex(functionDataUi, i)">
                                                    <i class="fa fa-minus"></i>
                                                </button>
                                            </ng-container>
                                        </ng-container>
                                    </div>
                            

                                    <!-- Data Display (depends on Property Type) -->
                                    <div class="col-sm-10">
                                        <input id="functionParam-{{functionDataUi.functionParameter.key}}-{{i}}"
                                            class="form-control" [(ngModel)]="dataObject.value" type="text" [delay]="1000" />
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
            </ng-container>
        </div>


    <div class="modal-footer">
        <button type="button" class="btn btn-default" (click)="hide()">
            <i class="fa fa-ban"></i> Close
        </button>
        <button type="button" class="btn btn-primary" (click)="executeFunctionClicked()">
            <i class="fa fa-check"></i> Confirm
        </button>
    </div>

    </div>
</div>